import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { listProjectCartridges } from "@/api/cartridges";
import { queryKeys } from "@/lib/queryKeys";
import type { ProjectCartridgeInfo } from "@/types/cartridge";

export function useProjectCartridges(projectId: string) {
  const query = useQuery<ProjectCartridgeInfo[]>({
    queryKey: queryKeys.cartridges.forProject(projectId),
    queryFn: () => listProjectCartridges(projectId),
    enabled: Boolean(projectId),
  });

  const refetch = useCallback(() => {
    void query.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.refetch]);

  return {
    cartridges: query.data ?? [],
    loading: query.isLoading,
    error: query.error ? "Failed to load project cartridges" : "",
    refetch,
  };
}
